import TeamsDark from '@Resources/assets/icons/dark/teams.svg';
import TeamsLight from '@Resources/assets/icons/light/teams.svg';
import { SvgIcon, Tooltip } from '@mui/material';
import React from 'react';
import IconButton from '@Components/IconButton/IconButton';
import Styles from '@Components/IconButton/IconButton.scss';
import { SettingsType } from '@Components/Settings/SettingsType';
import { ISettingsProps } from '../../Interfaces';

const Teams = (props: ISettingsProps) => {
    const { onSettingsBtnClick, isSubmitting, settingsType, id } = props;

    const isSelected = settingsType === SettingsType.TEAMSADMIN;

    return (
        <Tooltip title="Team Admin Settings">
            <div className={Styles.iconButtonWrapper}>
                <IconButton
                    id={id}
                    onClick={() => onSettingsBtnClick(SettingsType.TEAMSADMIN)}
                    disabled={isSubmitting}
                    isSelected={isSelected}
                    icon={
                        <SvgIcon inheritViewBox>
                            {isSelected ? <TeamsLight /> : <TeamsDark />}
                        </SvgIcon>
                    }
                />
            </div>
        </Tooltip>
    );
};

export default Teams;
